import { Component, Input } from '@angular/core';

@Component({
  selector: 'kt-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class ProgressBarComponent {
  @Input() color:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'danger'
    | 'warning'
    | 'success'
    | 'neutral' = 'neutral';
  @Input() total: number;
  @Input() progress: number;
  @Input() type: 'PERCENTAGE' | 'NUMBER';
}
